module.exports = __webpack_public_path__ + "img/pose-f-3.01b3089a.png";